<template>
  <v-dialog retain-focus persistent width="300" :value="showDialog">
    <v-card color="primary" dark>
      <v-card-text>
        <slot>
          <span class="d-inline-block my-2">{{ $t('app.standBy') }}</span>
        </slot>

        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>

        <input ref="input" tabindex="-1" type="text" class="visually-hidden" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const PENDING_DIALOG_CLASS = 'pending-dialog'

export default {
  name: 'PendingDialog',
  props: {
    showDialog: Boolean,
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        document.body.classList.add(PENDING_DIALOG_CLASS)
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      } else {
        document.body.classList.remove(PENDING_DIALOG_CLASS)
      }
    },
  },
}
</script>
<style lang="scss" module>
:global(.pending-dialog) {
  :global(.v-overlay).base-layout__overlay {
    top: 0 !important;
    bottom: 0 !important;
  }
}
</style>
